import React from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Desktop Images
import hero_1 from "../../assets/hero-1.png";
import hero_2 from "../../assets/hero-2.png";
import hero_3 from "../../assets/hero-3.png";

// Mobile Images
import m_hero_1 from "../../assets/mobile-hero-1.png";
import m_hero_2 from "../../assets/mobile-hero-2.png";
import m_hero_3 from "../../assets/mobile-hero-3.png";

// Import modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  // Desktop + Mobile image pairs
  const bannerImages = [
    {
      desktop: hero_1,
      mobile: m_hero_1,
    },
    {
      desktop: hero_2,
      mobile: m_hero_2,
    },
    {
      desktop: hero_3,
      mobile: m_hero_3,
    },
  ];

  return (
    <div className="w-full">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        className="w-full"
      >
        {bannerImages.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="w-full flex justify-center items-center relative cursor-pointer overflow-hidden"
              onClick={() => navigate("/fragrance")}
            >
              <picture className="w-full">
                {/* Mobile Image */}
                <source
                  media="(max-width: 768px)"
                  srcSet={slide.mobile}
                />

                {/* Desktop Image */}
                <img
                  src={slide.desktop}
                  alt={`banner-${index}`}
                  className="w-full h-auto object-contain transition-transform duration-500 ease-in-out hover:scale-105"
                />
              </picture>

              {/* Optional Overlay */}
              {/* 
              <div className="absolute inset-0 bg-black bg-opacity-0 transition-opacity duration-500 hover:bg-opacity-30"></div> 
              */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Hero;